export type Service<T extends ServiceOptionValue = ServiceValue> = {
  name?: string
  description?: string
  type?: string
  items?: ServiceItem<T>[]
}

// The actual service codes will be aligned with the BE
export type ServiceValue = 'RegularMaintenance' | 'Repair' | 'MOT' | 'EOL'
// CollectAndReturn is the legacy mapping of the PickupAndReturn service
// To be deprecated in:
export type LegacyAdditionalServiceValue =
  | 'CollectAndReturn'
  | 'ReplacementVehicle'

export type AdditionalServiceValue =
  | 'PickupAndReturn'
  | 'ReplacementVehicle'
  | 'ComplementaryCleaning'

export type ServiceOptionValue =
  | ServiceValue
  | LegacyAdditionalServiceValue
  | AdditionalServiceValue

export type ServiceItem<T extends ServiceOptionValue = ServiceOptionValue> = {
  code: T
  value: T
}

export enum ServiceType {
  Isp = 'ISP',
  Oem = 'OEM',
}
